import Logger from '../Logger';

/**
 * Helper classfor MediaDeviceRecorder, contains any helper private functions
 */
export default class MediaRecorderHelpers {
    /**
     * Creates instance of MediaRecorderHelpers
     * @param{ConfigurationManager} configurationManager entity to get configuration
     */
    constructor(configurationManager) {
        this.logger = new Logger('REC-HLPR', configurationManager.isDebugMode());
    }

    /**
     * @param{Error} error which received from getUserMedia
     * @return {boolean}
     */
    isErrorMeanWebcamBusy(error) {
        this.logger.logDebug(error);
        return (error && error.message
            && (error.message === 'Can not satisfy constraints'
                || error.message.name === 'SourceUnavailableError'
                || error.message.name === 'NotReadableError'));
    }

    /**
     * Checks if we have proper tracks for all requested devices
     * @param{Stream} stream received from getUserMedia
     * @param{Object.<{
     *   video: Object.<Device>,
     *   audio: Object.<Device>
     * }>} devices is list of devices which were used to get stream
     * @return {Promise<Object.<{
     *   allowed: boolean,
     *   video: boolean,
     *   audio: boolean,
     *   }>
     * >}
     */
    isAllRequiredTracksInStreamAllowed(stream, devices) {
        return new Promise((resolve, reject) => {
            const result = { allowed: true };
            const promises = [Promise.resolve()];
            if (devices.video) {
                promises.push(stream.getVideoTrack().then((track) => {
                    if (!track) {
                        this.logger.logDebug('videotrack not found in the stream');
                        result.allowed = false;
                        result.video = false;
                    }
                }));
            }

            if (result.allowed && devices.audio) {
                promises.push(stream.getAudioTrack().then((track) => {
                    if (!track) {
                        this.logger.logDebug('audiotrack not found in the stream');
                        result.allowed = false;
                        result.audio = false;
                    }
                }));
            }

            Promise.all(promises).then(() => {
                resolve(result);
            }, reject);
        });
    }

    /**
     * clean all stored permission attributes from devices
     * @param{Object.<{
     *   video: Object.<Device>,
     *   audio: Object.<Device>
     * }>} inputDevices devices to be updated
     * @return {*}
     */
    cleanDevicesPermissions(inputDevices) {
        this.logger.logDebug(inputDevices);
        const devices = inputDevices;
        if (devices.video) {
            devices.video.allowed = undefined;
            devices.video.denied = undefined;
            devices.video.permissionState = undefined;
        }

        if (devices.audio) {
            devices.audio.allowed = undefined;
            devices.audio.denied = undefined;
            devices.audio.permissionState = undefined;
        }

        this.logger.logDebug(devices);

        return devices;
    }
}
